import React from 'react';
import { Shield, CheckCircle, AlertTriangle, UserX } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { PublicLayout } from '../../components/layout/PublicLayout';

import { BackButton } from '../../components/ui/BackButton';

export const CodeOfConductPage: React.FC = () => {
    return (
        <PublicLayout>
            <div className="min-h-screen bg-[#0A0A0A] pt-24 pb-12 px-4 md:px-8">
                <div className="max-w-4xl mx-auto space-y-12">
                    {/* Header */}
                    <div className="text-center space-y-4 relative">
                        <div className="absolute left-0 top-0">
                            <BackButton />
                        </div>
                        <h1 className="text-5xl md:text-6xl font-display font-bold text-white tracking-tight">
                            Code of <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF991C] to-[#7C4DFF]">Conduct</span>
                        </h1>
                        <p className="text-xl text-white/60 max-w-2xl mx-auto">
                            To ensure a safe, inclusive, and enjoyable experience for everyone, all participants are expected to adhere to the following guidelines.
                        </p>
                    </div>

                    <div className="grid gap-8">
                        <Card className="p-8 bg-white/[0.03] border border-white/[0.08] rounded-2xl backdrop-blur-xl">
                            <div className="flex items-start gap-4">
                                <div className="p-3 rounded-xl bg-[#7C4DFF]/10 text-[#7C4DFF]">
                                    <Shield className="w-8 h-8" />
                                </div>
                                <div className="space-y-4">
                                    <h2 className="text-2xl font-display font-bold text-white">General Behavior</h2>
                                    <ul className="space-y-3 text-white/60">
                                        <li className="flex items-start gap-3">
                                            <CheckCircle className="w-5 h-5 text-[#FF991C] shrink-0 mt-1" />
                                            <span>Treat all participants, organizers, and staff with respect and dignity.</span>
                                        </li>
                                        <li className="flex items-start gap-3">
                                            <CheckCircle className="w-5 h-5 text-[#FF991C] shrink-0 mt-1" />
                                            <span>Maintain a spirit of healthy competition and sportsmanship.</span>
                                        </li>
                                        <li className="flex items-start gap-3">
                                            <CheckCircle className="w-5 h-5 text-[#FF991C] shrink-0 mt-1" />
                                            <span>Follow the instructions given by the event coordinators and volunteers.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Card>

                        <Card className="p-8 bg-white/[0.03] border border-white/[0.08] rounded-2xl backdrop-blur-xl">
                            <div className="flex items-start gap-4">
                                <div className="p-3 rounded-xl bg-[#EF4444]/10 text-[#EF4444]">
                                    <AlertTriangle className="w-8 h-8" />
                                </div>
                                <div className="space-y-4">
                                    <h2 className="text-2xl font-display font-bold text-white">Prohibited Actions</h2>
                                    <ul className="space-y-3 text-white/60">
                                        <li className="flex items-start gap-3">
                                            <UserX className="w-5 h-5 text-[#EF4444] shrink-0 mt-1" />
                                            <span>Harassment, discrimination, or bullying of any kind will not be tolerated.</span>
                                        </li>
                                        <li className="flex items-start gap-3">
                                            <UserX className="w-5 h-5 text-[#EF4444] shrink-0 mt-1" />
                                            <span>Damage to school property or venue facilities is strictly prohibited.</span>
                                        </li>
                                        <li className="flex items-start gap-3">
                                            <UserX className="w-5 h-5 text-[#EF4444] shrink-0 mt-1" />
                                            <span>Use of unfair means or cheating during competitions will lead to immediate disqualification.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Card>

                        <Card className="p-8 bg-white/[0.03] border border-white/[0.08] rounded-2xl backdrop-blur-xl">
                            <div className="space-y-4">
                                <h2 className="text-2xl font-display font-bold text-white">Reporting Violations</h2>
                                <p className="text-white/60 leading-relaxed">
                                    If you witness or experience any violation of this Code of Conduct, please report it immediately to the nearest event organizer or volunteer. You can also contact us at <a href="mailto:enigma@jsgc.in" className="text-[#7C4DFF] hover:underline">enigma@jsgc.in</a>.
                                </p>
                                <p className="text-white/40 text-sm italic border-t border-white/10 pt-4 mt-4">
                                    The organizing committee reserves the right to take appropriate action, including expulsion from the event, for any violations of this Code of Conduct.
                                </p>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </PublicLayout>
    );
};
